import { IonSpinner } from '@ionic/react';
import * as React from 'react';

import CustomModal from '../../../../ui/elements/CustomModal/CustomModal';
import SubPageWrapperForModal from '../../../../ui/elements/CustomModal/SubPageWrapperForModal';
import BeforeContentSwiper from '../../../../ui/elements/SwiperWithNavigation/BeforeContentSwiper';
import type { ObjectID } from '../../../types';
import { useLocationById } from '../useLocations';
import LocationDetails from './LocationDetails';

const SLIDER_OPTIONS = {
  touchReleaseOnEdges: true,
  longSwipes: false,
  preloadImages: true,
};

const LocationDetailsModal = ({
  locationId,
  resetLocation,
}: {
  locationId: ObjectID;
  resetLocation: () => void;
}): JSX.Element => {
  const location = useLocationById(locationId);

  return (
    <>
      <CustomModal
        isOpen={Boolean(locationId)}
        onDidDismiss={e => {
          e.stopPropagation();
          resetLocation();
        }}
      >
        <SubPageWrapperForModal
          wrapperClassName="expert-profile"
          beforeContent={
            <div className="treatment-details-before-content">
              {location.value && (
                <BeforeContentSwiper
                  data={location.value}
                  sliderOptions={SLIDER_OPTIONS}
                />
              )}
            </div>
          }
          onClose={e => {
            e.stopPropagation();
            resetLocation();
          }}
        >
          {!location.value && <IonSpinner />}
          {location.value && <LocationDetails location={location.value} />}
        </SubPageWrapperForModal>
      </CustomModal>
    </>
  );
};

export default LocationDetailsModal;
